import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { effAmt } from '@/utils';
import Amt from '@/common/components/amt';
import { useMemo } from 'react';
import style from './style.module.scss';
import txStyle from '../tx.module.scss';
export default function TransactionsCategories({ transactions: txs, currency, categories }) {
    const catGroups = useMemo(() => {
        const g = {};
        txs.forEach((tx) => {
            const e = effAmt(tx);
            if (!e)
                return;
            const key = tx.category || 'other';
            if (!g[key])
                g[key] = { exp: 0, inc: 0 };
            if (tx.type === 'expense')
                g[key].exp += e;
            else
                g[key].inc += e;
        });
        return Object.entries(g).sort((a, b) => b[1].exp + b[1].inc - (a[1].exp + a[1].inc));
    }, [txs]);
    return (_jsxs("div", { className: txStyle["tx-section"], children: [_jsx("div", { className: txStyle["tx-section-title"], children: "\u041F\u043E \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043C" }), catGroups.map(([catId, { exp, inc }]) => {
                const cat = categories.find(c => c.id === catId) || { icon: '📦', label: catId };
                return (_jsxs("div", { className: style["mcat-row"], children: [_jsx("span", { className: style["mcat-icon"], children: cat.icon }), _jsx("span", { className: style["mcat-label"], children: cat.label }), _jsxs("div", { className: style["mcat-amounts"], children: [exp > 0 && _jsx("span", { className: style["mcat-exp"], children: _jsx(Amt, { value: exp, currency: currency, sign: "\u2212" }) }), inc > 0 && _jsx("span", { className: style["mcat-inc"], children: _jsx(Amt, { value: inc, currency: currency, sign: "+" }) })] })] }, catId));
            })] }));
}
